module.exports = __webpack_public_path__ + "img/symbol_13_x5.72089f72.png";